import {formatDateUTCBr} from "@utils";
import {INotification} from "../../../providers/NotificationProvider";

const NotificationProposalItem = ({ driverName, startDateTime, proposedDate, destinyName }: INotification) => {
  return (
    <div className="padding-y-15 padding-x-25">
      <div>
        <span className="text-size-12 text-color-dark text-bold line-height-20">Agendamento</span>
      </div>

      <div className="display-flex align-items-center gap-15 padding-y-10">
        <div className="bg-warning width-40 height-40 display-flex align-items-center justify-content-center rounded-circle padding-bottom-5">
          <span className="rioglyph rioglyph-route-option text-size-h4 text-color-white margin-top-4" />
        </div>

        <div>
          <div className="display-flex gap-10 align-items-center">
            <span className="text-bold text-size-14 line-height-20 text-capitalize">{driverName}</span>
            <div className="width-4 height-4 bg-black rounded"/>
            <span className="text-bold text-size-14 text-color-warning">Sugeriu novo dia e hora</span>
          </div>

          <div className="display-flex gap-10 align-items-center">
            <div className="display-flex gap-4 align-items-center">
              <span
                className="text-size-12 line-height-20 text-normal text-decoration-line-through">{formatDateUTCBr(startDateTime)}</span>
              <span className="rioglyph rioglyph-calendar text-size-12 text-color-gray"></span>
              <span className="text-size-12 line-height-20 text-normal">{formatDateUTCBr(proposedDate)}</span>
            </div>
            <div className="width-4 height-4 bg-black rounded"/>
            <div className="display-flex gap-4 align-items-center">
              <span className="rioglyph rioglyph-finish text-size-14 text-color-gray"></span>
              <span className="text-size-12 line-height-20 text-normal">{destinyName}</span>
            </div>
          </div>

        </div>


      </div>
    </div>
  )
}

export default NotificationProposalItem;